import { render } from "./TextSection.vue?vue&type=template&id=3d9d7138"
import script from "./TextSection.vue?vue&type=script&lang=js"
export * from "./TextSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__